import { useMemo } from 'react';
import { useConfigService } from '@thd-nucleus/experience-context';
import { formatBundles } from '../utils/product-bundle-utils';

export const useGetBundleConfigSwitch = () => {
  const bundleProductsRaw = useConfigService('bundleProducts') || null;
  const selectableVariantProductsRaw = useConfigService('selectableVariantProducts') || null;
  const configExperienceType = useConfigService('bundleExperience') || null;
  const configBundleType = useConfigService('bundleType') || null;
  const configBundleProductsDetails = useConfigService('bundleProductsDetails') || null;
  const enableAccessories = useConfigService('fs:isAccessoriesFeatureEnabled') || null;
  const enableRemoveItemPromoImage = useConfigService('fs:isRemoveItemPromoImageEnabled') || null;

  const configBundleProducts = useMemo(
    () => formatBundles(bundleProductsRaw),
    [bundleProductsRaw]
  );

  const configSelectableVariantProducts = useMemo(
    () => formatBundles(selectableVariantProductsRaw),
    [selectableVariantProductsRaw]
  );

  return {
    configBundleProducts,
    configSelectableVariantProducts,
    configExperienceType,
    configBundleType,
    configBundleProductsDetails,
    enableAccessories,
    enableRemoveItemPromoImage
  } || {};

};